import React from 'react';
import { ZenturaLanding } from './pages/ZenturaLanding';
export function App() {
  return <ZenturaLanding data-id="element-0" />;
}